export default __webpack_public_path__ + "static/media/Edge HL - Flag Select Member.svg";